import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './FAQPage.css';

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const faqRef = ref(database, 'faq');
    const unsubscribe = onValue(faqRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setFaqs(list);
      } else {
        setFaqs([]);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="faq-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Sıkça Sorulan Sorular</h1>
          <p className="page-hero-subtitle">Merak ettiklerinizin yanıtları</p>
        </div>
      </div>
      <div className="faq-page-content">
        <div className="container">
          {loading ? (
            <div className="faq-loading"><p>Yükleniyor...</p></div>
          ) : faqs.length === 0 ? (
            <div className="faq-empty"><p>Henüz soru eklenmemiş.</p></div>
          ) : (
            <div className="faq-list">
              {faqs.map((item) => (
                <div
                  key={item.id}
                  className={`faq-item ${openId === item.id ? 'open' : ''}`}
                >
                  <button
                    type="button"
                    className="faq-question"
                    onClick={() => setOpenId(openId === item.id ? null : item.id)}
                  >
                    <span>{item.question}</span>
                    <span className="faq-icon">{openId === item.id ? '−' : '+'}</span>
                  </button>
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
